import React, { useState } from "react";
import templateManagerIcon from "../../images/templateIconNoBg.svg";
import bannerManagerIcon from "../../images/BannerImgWithNoBg.svg";

import bannerManagerIconWithBg from "../../images/BannerImgWithBG (3).svg";
import templateManagerIconWithBg from "../../images/TemplateIconwithBg.svg";
import { TrendingUpOutlined } from "@mui/icons-material";
const BannerTempManagerHeader = ({
  selectedTab,
  setSelectedtab,
  setIsOpen,
  isOpen,
  banner,
  toggleLandingPage,
}) => {
  const handleClickBannerManager = (type) => {
    if (type === "Banner") {
      setIsOpen(true);
      setSelectedtab(0);
    } else if (type === "Template") {
      setIsOpen(true);
      setSelectedtab(1);
    }
  };

  return (
    <div className="bnm-temp-header">
      <div className="bnm-temp-left-side">
        <div className="manager-name"> {banner ? "Banner" : "Template"}</div>
        <div className="crate-browse-text">
          {" "}
          {banner ? "Create & Browse Banners" : "Create & Browse Templates"}
        </div>
      </div>
      <div className="manager-type-class">
        {banner ? (
          <img src={bannerManagerIconWithBg} className="bnrmanagerBox"></img>
        ) : (
          <img
            src={bannerManagerIcon}
            onClick={() => toggleLandingPage("banner")}
            className="managerWithBg"
          ></img>
        )}

        {/* {!banner ? (
          <img src={templateManagerIconWithBg} className="bnrmanagerBox"></img>
        ) : (
          <img
            src={templateManagerIcon}
            onClick={() => toggleLandingPage("template")}
            className="managerWithBgtemplate"
          ></img>
        )} */}
      </div>
      <div></div>
    </div>
  );
};
export default BannerTempManagerHeader;
